/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { PAYROLL_DISTRIBUTION_STATUSES_OPTIONS } from 'domain/finance/payroll/payrollDistribution/usePayrollDistributionService';

const PayrollDistributionStatusField = (props: FieldProps) => {
  return <EnumField options={PAYROLL_DISTRIBUTION_STATUSES_OPTIONS} {...props} />;
};

export default PayrollDistributionStatusField;
